import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Gates a route behind an active session. Checks both Redux and localStorage
// for the access token (not the `user` object) so a page refresh with a
// stored token doesn't flash-redirect to sign-in before getProfile() resolves.
const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { access_token } = useSelector((state) => state.auth);
    const storedAccessToken = localStorage.getItem('access_token');
    const isAuthenticated = Boolean(access_token || storedAccessToken);

    if (!isAuthenticated) {
        return <Navigate to="/sign-in" replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;
